<template>
    <header ref="header" class="header">
        <div class="container">
            <div class="align-items-center d-flex w-100 over-desktop-only">
                <a href="/" class="logo">
                    <Logo />
                </a>
                <div v-if="user && user.prospecting_tool_attributes" class="pro-badge ms-3"
                    :class="{ 'isTrial': user.prospecting_tool_attributes && user.prospecting_tool_attributes.isTrial }">
                    PRO
                </div>
                <!-- Desktop navigation bar -->
                <nav class="w-100">
                    <ul class="user-menu main-menu">
                        <div class="d-flex justify-content-evenly w-100">
                            <li class="position-relative">
                                <a href="#" class="main-menu-dropdown-trigger"
                                    @click.prevent="dropdownShown.first = !dropdownShown.first">
                                    How it works
                                </a>
                                <div class="main-menu-dropdown" :class="{ 'd-flex flex-column': dropdownShown.first }"
                                    v-on-clickaway="() => {
                                        dropdownShown.first = false;
                                    }
                                        ">
                                    <a href="/agents">Agents</a>
                                    <a href="/tenant">Tenants</a>
                                    <a href="/landlord">Landlord</a>
                                </div>
                            </li>
                            <li>
                                <a href="/w/area-guides">Area guides</a>
                            </li>
                            <li class="position-relative">
                                <a href="#" class="main-menu-dropdown-trigger"
                                    @click.prevent="dropdownShown.second = !dropdownShown.second">
                                    Rent
                                </a>
                                <div class="main-menu-dropdown" :class="{ 'd-flex flex-column': dropdownShown.second }"
                                    v-on-clickaway="() => {
                                        dropdownShown.second = false;
                                    }
                                        ">
                                    <a href="/properties-to-rent">Properties to rent</a>
                                    <a href="/renter">How it works</a>
                                </div>
                            </li>
                        </div>
                        <template v-if="globalState.isAuthUser">
                            <li>
                                <span class="user-menu__icon-link">
                                    <span class="user-menu__avatar">
                                        <img v-if="globalState.userProfilePicture" :src="globalState.userProfilePicture"
                                            onerror="this.onerror=null;this.src='/img/icons/user.png'" alt="avatar" />
                                        <svg v-else width="18" height="20" viewBox="0 0 18 20">
                                            <use xlink:href="#svg-icn-user"></use>
                                        </svg>
                                        <a class="new-message-notification" href="/chat"
                                            v-if="conversationsNotificationsCount > 0">new</a>
                                    </span>
                                    <div class="user-menu__hbg hidden-small"><span></span><span></span><span></span>
                                    </div>
                                </span>

                                <ul>
                                    <li class="mb-1">
                                        Hello, <strong v-if="user">{{ user.public_name }}</strong><br />
                                    </li>
                                    <li>
                                        <a href="/dashboard"> Dashboard </a>
                                    </li>
                                    <li v-if="globalState.isCompany">
                                        <a href="/agents/active">
                                            Negotiators <span class="primary-text-color" v-if="user">{{
                                                user.agents_count }}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/my-adverts">
                                            Adverts <span class="primary-text-color" v-if="user">{{ user.ads_count
                                                }}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/favorites">
                                            Favourites <span class="primary-text-color" v-if="user">{{
                                                user.favorites_count }}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/my-alerts">
                                            Alerts <span class="primary-text-color" v-if="user">{{ user.alerts_count
                                                }}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/chat">
                                            Chats <span v-if="conversationsNotificationsCount > 0"
                                                class="primary-text-color">{{
                                                    conversationsNotificationsCount }}</span>
                                        </a>
                                    </li>
                                    <li
                                        v-if="user && user.prospecting_tool_attributes && user.prospecting_tool_attributes.isActive">
                                        <a href="/prospecting-tool"> Stock Finder </a>
                                    </li>
                                    <li>
                                        <a href="/logout" @click="doLogout"> Logout </a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <span class="user-menu">
                                    <span class="user-menu__bell">
                                        <svg fill="#8a2be2" height="400px" width="200px" version="1.1" id="svg-icn-bell"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 611.999 611.999"
                                            xml:space="preserve">
                                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round"
                                                stroke-linejoin="round">
                                            </g>
                                            <g id="SVGRepo_iconCarrier">
                                                <g>
                                                    <g>
                                                        <g>
                                                            <path
                                                                d="M570.107,500.254c-65.037-29.371-67.511-155.441-67.559-158.622v-84.578c0-81.402-49.742-151.399-120.427-181.203 C381.969,34,347.883,0,306.001,0c-41.883,0-75.968,34.002-76.121,75.849c-70.682,29.804-120.425,99.801-120.425,181.203v84.578 c-0.046,3.181-2.522,129.251-67.561,158.622c-7.409,3.347-11.481,11.412-9.768,19.36c1.711,7.949,8.74,13.626,16.871,13.626 h164.88c3.38,18.594,12.172,35.892,25.619,49.903c17.86,18.608,41.479,28.856,66.502,28.856 c25.025,0,48.644-10.248,66.502-28.856c13.449-14.012,22.241-31.311,25.619-49.903h164.88c8.131,0,15.159-5.676,16.872-13.626 C581.586,511.664,577.516,503.6,570.107,500.254z M484.434,439.859c6.837,20.728,16.518,41.544,30.246,58.866H97.32 c13.726-17.32,23.407-38.135,30.244-58.866H484.434z M306.001,34.515c18.945,0,34.963,12.73,39.975,30.082 c-12.912-2.678-26.282-4.09-39.975-4.09s-27.063,1.411-39.975,4.09C271.039,47.246,287.057,34.515,306.001,34.515z M143.97,341.736v-84.685c0-89.343,72.686-162.029,162.031-162.029s162.031,72.686,162.031,162.029v84.826 c0.023,2.596,0.427,29.879,7.303,63.465H136.663C143.543,371.724,143.949,344.393,143.97,341.736z M306.001,577.485 c-26.341,0-49.33-18.992-56.709-44.246h113.416C355.329,558.493,332.344,577.485,306.001,577.485z">
                                                            </path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <span class="in-app-notification-count"
                                            v-if="user && user.in_app_notifications && user.in_app_notifications.unreadCount > 0">
                                            {{ user.in_app_notifications.unreadCount }}
                                        </span>
                                    </span>
                                </span>
                                <ul class="in-app-notifications-list">
                                    <li v-if="inAppNotifications.length">
                                        <span @click="markAllInAppNotificationsAsRead"
                                            style="color:#e50695;cursor:pointer;">
                                            Mark all as read
                                        </span>
                                    </li>
                                    <li v-for="notification in inAppNotifications" :key="notification.id">
                                        <a :href="notification.notification_data.target" target="_blank"
                                            :class="{ 'unread-notification': !notification.is_read }">
                                            {{ notification.body }}
                                        </a>
                                    </li>
                                    <li
                                        v-if="user && user.in_app_notifications.recordsTotal > inAppNotifications.length">
                                        <a href="#" @click.prevent="loadMoreNotifications"
                                            style="color:#e50695;cursor:pointer;">
                                            Load More
                                        </a>
                                    </li>
                                    <li v-if="inAppNotifications.length < 1">
                                        No notifications
                                    </li>
                                </ul>
                            </li>
                        </template>
                        <template v-else>
                            <li>
                                <a href="#" @click.prevent="showLoginModal = true">Log in</a>
                            </li>
                        </template>
                        <li>
                            <a href="/select-advert-type" class="btn btn--primary" style="border-radius: 10px;">
                                Post Ad
                            </a>
                        </li>
                        <li v-if="!globalState.isAuthUser">
                            <template v-if="isAgentPage">
                                <a href="/book-a-demo" class="btn btn--primary-empty" style="border-radius: 10px;">
                                    Book a demo
                                </a>
                            </template>
                            <template v-else>
                                <a href="/book-a-demo" class="btn btn--primary-empty" style="border-radius: 10px;">
                                    Book a demo
                                </a>
                            </template>
                        </li>
                    </ul>
                </nav>
                <!-- End desktop navigation bar -->
            </div>

            <!-- Mobile navigation bar -->
            <div class="user-menu d-flex justify-content-between gap-2 align-items-center w-100 less-desktop-only">

                <div class="d-flex gap-1 align-items-center">
                    <a class="px-2" style="height: 25px;" href="#" @click.prevent="$root.$emit('toggleSidebar', true)">
                        <img src="/img/icons/burger-menu.svg" width="25" class="mobile-menu-toggle" />
                    </a>
                    <div v-if="user && user.prospecting_tool_attributes" class="pro-badge"
                        :class="{ 'isTrial': user.prospecting_tool_attributes && user.prospecting_tool_attributes.isTrial }">
                        PRO
                    </div>
                </div>
                <a href="/" class="logo">
                    <Logo />
                </a>
                <a href="/select-advert-type" class="btn btn--primary" style="border-radius: 10px;">Post Ad</a>

                <!-- Mobile menu content -->
                <Teleport to=".main-content">
                    <Sidebar class="less-desktop-only">
                        <nav class="overflow-y-auto mb-3">
                            <ul class="ps-2 pb-4 d-flex flex-column gap-3 mobile-main-menu">
                                <!-- Non auth user menu -->
                                <template v-if="!globalState.isAuthUser">
                                    <template v-if="isAgentPage">
                                        <li>
                                            <a href="/book-a-demo" class="btn btn--primary-empty w-75"
                                                style="border-radius: 10px;">Book a demo</a>
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li>
                                            <a href="/book-a-demo" class="btn btn--primary-empty w-75"
                                                style="border-radius: 10px;">Book a demo</a>
                                        </li>
                                    </template>
                                    <li>
                                        <a href="#" @click.prevent="showLoginModal = true" class="login-link">Log in</a>
                                    </li>
                                </template>
                                <!-- End non auth user menu -->

                                <!-- Auth user menu -->
                                <template v-else>
                                    <li>
                                        <a href="/dashboard"> Dashboard </a>
                                    </li>
                                    <li v-if="globalState.isCompany">
                                        <a href="/agents/active">
                                            Negotiators <span class="count-label me-2" v-if="user">{{
                                                user.agents_count }}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/my-adverts">
                                            Adverts <span class="count-label me-2" v-if="user">{{ user.ads_count
                                                }}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/favorites">
                                            Favourites <span class="count-label me-2" v-if="user">{{
                                                user.favorites_count }}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/my-alerts">
                                            Alerts <span class="count-label me-2" v-if="user">{{
                                                user.alerts_count }}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/chat">
                                            Chats <span v-if="conversationsNotificationsCount > 0"
                                                class="count-label me-2">{{
                                                    conversationsNotificationsCount }}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/profile"> Profile </a>
                                    </li>
                                    <li v-if="user && user.is_company">
                                        <a href="/lead-manager"> Lead Manager </a>
                                    </li>
                                    <!-- <li v-if="user && user.is_company">
                                        <a href="/tenant-referencing"> Tenant Referencing </a>
                                    </li> -->
                                    <li
                                        v-if="user && user.prospecting_tool_attributes && user.prospecting_tool_attributes.isActive">
                                        <a href="/prospecting-tool"> Stock Finder </a>
                                    </li>
                                    <li
                                        v-if="user && user.prospecting_tool_attributes && user.prospecting_tool_attributes.isActive">
                                        <a href="/tenanted-properties"> Coming to market </a>
                                    </li>
                                    <li
                                        v-if="user && user.prospecting_tool_attributes && user.prospecting_tool_attributes.isActive && user.prospecting_tool_attributes.hasDatabase">
                                        <a href="/prospecting-database">My Database </a>
                                    </li>
                                    <li
                                        v-if="user && user.land_locator_attributes && user.land_locator_attributes.isActive">
                                        <a href="/land-locator">Land Locator</a>
                                    </li>
                                    <li>
                                        <a href="/logout" @click="doLogout"> Logout </a>
                                    </li>
                                </template>
                                <!-- End auth user menu -->

                                <hr class="mt-0" />

                                <li>
                                    <a href="/renter">How it works</a>
                                </li>
                                <li>
                                    <a href="/w/area-guides">Area Guides</a>
                                </li>
                                <li>
                                    <a href="/agents">For agents</a>
                                </li>
                                <li>
                                    <a href="/landlord">For landlords</a>
                                </li>
                                <li>
                                    <a href="/tenant">For tenants</a>
                                </li>
                            </ul>
                        </nav>
                    </Sidebar>
                </Teleport>
            </div>
            <!-- End mobile navigation bar -->
        </div>
        <template v-if="!globalState.isAuthUser">
            <LoginModal :show-modal="showLoginModal" @close="showLoginModal = false"
                @open-register-modal="showRegisterModal = true"
                @open-forgot-password-modal="showForgotPasswordModal = true" />
            <RegisterModal :show-modal="showRegisterModal" @close="showRegisterModal = false"
                @open-login-modal="showLoginModal = true" :fixedUserType="fixedUserType" />
        </template>
        <StartVerificationPhoneNumberModal :show-modal="showStartVerificationPhoneNumberModal"
            @open-verify-phone-number-modal="
                showVerifyPhoneNumberModal = true;
            verifyPhoneData = $event;
            " @close="showStartVerificationPhoneNumberModal = false" />
        <VerifyPhoneNumberModal :show-modal="showVerifyPhoneNumberModal" :verify-phone-data="verifyPhoneData"
            @open-send-verification-phone-number="showStartVerificationPhoneNumberModal = true"
            @close="showVerifyPhoneNumberModal = false" />
        <AdvertLimitReachedModal :show-modal="showAdvertLimitReachedModal" :message="advertLimitReachedMessage"
            @close="showAdvertLimitReachedModal = false" />
        <DownloadAppPopup :show-modal="showDownloadAppPopup" @close="onCloseDownloadAppPopup" />
        <ForgotPasswordModal :show-modal="showForgotPasswordModal" :show-login-link="!globalState.isAuthUser"
            @close="showForgotPasswordModal = false" @open-login-modal="showLoginModal = true" />
        <AcceptTermsAndConditionsModal :show-modal="showAcceptedTermsModal" @close="showAcceptedTermsModal = false" />
        <CompleteProfileModal :show-modal="showCompleteProfileModal" @close="onCloseCompleteProfileModal" />
        <ProspectingUploadReminderModal :show-modal="showProspectingUploadReminderModal"
            @close="onCloseProspectingUploadReminderModal" />
        <PendingSubscriptionPopup :show-modal="showPendingSubscriptionPopup" :subscriptionUrl="pendingSubscriptionUrl"
            @close="onClosePendingSubscriptionPopup" />
    </header>
</template>

<script>
import Sidebar from '@components/partials/Sidebar.vue';
import Logo from '@components/partials/icons/Logo.vue';
import Cookies from 'js-cookie';
import { directive as onClickaway } from 'vue-clickaway2';
import Teleport from 'vue2-teleport';
import { mapMutations, mapState } from 'vuex';
import { redirectTo } from '@helpers/url-handler';

const LoginModal = () => import('@components/Auth/partials/LoginModal.vue');
const RegisterModal = () => import('@components/Auth/partials/RegisterModal.vue');
const ForgotPasswordModal = () => import('@components/Auth/partials/ForgotPasswordModal.vue');
const StartVerificationPhoneNumberModal = () => import('@components/AdCard/partials/StartVerificationPhoneNumberModal.vue');
const VerifyPhoneNumberModal = () => import('@components/AdCard/partials/VerifyPhoneNumberModal.vue');
const AdvertLimitReachedModal = () => import('@components/AdCard/partials/AdvertLimitReachedModal.vue');
const DownloadAppPopup = () => import('@components/Popups/DownloadAppPopup.vue');
const AcceptTermsAndConditionsModal = () => import('@components/Popups/AcceptTermsAndConditionsModal.vue');
const CompleteProfileModal = () => import('@components/Popups/CompleteProfileModal.vue');
const ProspectingUploadReminderModal = () => import('@components/Popups/ProspectingUploadReminderModal.vue');
const PendingSubscriptionPopup = () => import('@components/ProspectingTool/partials/PendingSubscriptionPopup.vue');

export default {
    directives: {
        onClickaway,
    },
    components: {
        Logo,
        LoginModal,
        RegisterModal,
        ForgotPasswordModal,
        StartVerificationPhoneNumberModal,
        VerifyPhoneNumberModal,
        AdvertLimitReachedModal,
        DownloadAppPopup,
        Sidebar,
        AcceptTermsAndConditionsModal,
        Teleport,
        CompleteProfileModal,
        ProspectingUploadReminderModal,
        PendingSubscriptionPopup,
    },
    props: {
        globalState: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showLoginModal: false,
            showRegisterModal: false,
            showAcceptedTermsModal: false,
            showCompleteProfileModal: false,
            showForgotPasswordModal: false,
            showStartVerificationPhoneNumberModal: false,
            showVerifyPhoneNumberModal: false,
            showUpgradePlanModal: false,
            showMobileMenu: false,
            verifyPhoneData: {},
            showAdvertLimitReachedModal: false,
            advertLimitReachedMessage: '',
            conversationsNotificationsCount: 0,
            showDownloadAppPopup: false,
            showInvestPopup: false,
            showProspectingUploadReminderModal: false,
            showPendingSubscriptionPopup: false,
            pendingSubscriptionUrl: '',
            fixedUserType: '',
            preselectedPlan: '',
            showOptions: {
                howItWorks: false,
                rent: false,
            },
            dropdownShown: {
                first: false,
                second: false,
            },
            activateProspectingToolInfoText: '',
        };
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState(['pageState', 'inAppNotifications']),
        isAgentPage() {
            return window.location.pathname === '/agents';
        },
        isLandLocatorPage() {
            return window.location.pathname === '/land-locator';
        },
    },
    mounted() {
        this.$root.$on('open-login-modal', () => {
            this.showLoginModal = true;
        });
        this.$root.$on('open-register-modal', (fixedUserType) => {
            this.fixedUserType = fixedUserType ?? '';
            this.showRegisterModal = true;
        });
        this.$root.$on('open-forgot-password-modal', () => {
            this.showForgotPasswordModal = true;
        });
        this.$root.$on('open-start-phone-verification-modal', () => {
            this.showStartVerificationPhoneNumberModal = true;
        });
        this.$root.$on('open-advert-limit-reached-modal', (message) => {
            this.advertLimitReachedMessage = message;
            this.showAdvertLimitReachedModal = true;
        });
        this.$root.$on('open-prospecting-upload-reminder-modal', () => {
            this.showProspectingUploadReminderModal = true;
        });
        this.$root.$on('open-pending-subscription-popup', () => {
            this.showPendingSubscriptionPopup = true;
        });
        if (!this.isLandLocatorPage && !Cookies.get('download-app-popup-shown')) {
            setTimeout(() => {
                this.showDownloadAppPopup = true;
            }, 20000);
        }
    },
    watch: {
        user(user) {
            if (!user) {
                return;
            }

            if (this.globalState.acceptedTerms === false && user.is_company && !Cookies.get('declinedTerms')) {
                this.showAcceptedTermsModal = true;
            }
            if (this.globalState.hasCompletedProfile === false && !Cookies.get('shownCompleteProfileReminder')) {
                this.showCompleteProfileModal = true;
            }
            if (user.prospecting_tool_attributes
                && user.prospecting_tool_attributes.hasRecentDatabaseUploads
                && user.prospecting_tool_attributes.isActive
                && !Cookies.get('shownProspectingUploadReminder')
                && this.$route.path !== '/prospecting-database') {
                this.showProspectingUploadReminderModal = true;
            }
            if (user.prospecting_tool_attributes
                && user.prospecting_tool_attributes.trialRemainingDays === 0
                && !user.prospecting_tool_attributes.currentSubscriptionPlan.type
                && !Cookies.get('redirectToPricingTrialExpired')
                && this.$route.path !== '/pricing') {
                Cookies.set('redirectToPricingTrialExpired', 1);
                this.redirectTo('/pricing');
            }

            if (user.prospecting_tool_attributes
                && user.prospecting_tool_attributes.isPendingSubscription
                && !user.prospecting_tool_attributes.isPendingSubscriptionExpired
                && !Cookies.get('shownPendingSubscriptionPopup')
            ) {
                this.pendingSubscriptionUrl = user.prospecting_tool_attributes.pendingSubscriptionUrl;
                this.showPendingSubscriptionPopup = true;
            }
            this.conversationsNotificationsCount = user.conversations_notifications_count;
            this.listenForNotifications(user.uuid);
        },
    },
    methods: {
        ...mapMutations(['setInAppNotifications']),
        ...mapMutations('user', ['setUser']),
        redirectTo,
        listenForNotifications(userUuid) {
            window.LaravelEcho.private(`user.chat.notifications.${userUuid}`).listen('.newChatMessage', (e) => {
                const { conversationsNotificationsCount } = e;
                this.conversationsNotificationsCount = conversationsNotificationsCount;
            });

            window.LaravelEcho.private(`user.video.notifications.${userUuid}`)
                .listen('.join', (e) => {
                    console.log(`${e.userUuid} joined video chat.`);
                })
                .listen('.join', (e) => {
                    console.log(`${e.userUuid} leaved video chat.`);
                });
        },
        onCloseDownloadAppPopup() {
            Cookies.set('download-app-popup-shown', 1, { expires: 1 });
            this.showDownloadAppPopup = false;
        },
        onCloseCompleteProfileModal() {
            Cookies.set('shownCompleteProfileReminder', 1, { expires: 1 / 24 });
            this.showCompleteProfileModal = false;
        },
        onCloseProspectingUploadReminderModal() {
            Cookies.set('shownProspectingUploadReminder', 1, { expires: 1 / 24 });
            this.showProspectingUploadReminderModal = false;
        },
        onClosePendingSubscriptionPopup() {
            Cookies.set('shownPendingSubscriptionPopup', 1, { expires: 1 });
            this.showPendingSubscriptionPopup = false;
        },
        loadMoreNotifications() {
            this.axios.get(`/api/user/notifications?start=${this.inAppNotifications.length}&length=10`).then(({ data }) => {
                this.setInAppNotifications([...this.inAppNotifications, ...data.data]);
            });
        },
        markAllInAppNotificationsAsRead() {
            this.axios.patch('/api/user/notifications/mark-all-as-read').then(({ data }) => {
                this.setInAppNotifications(data.data);
            });
        },
        onUpdateUser(user) {
            this.setUser(user);
        },
    },
};
</script>
